<template>
  <v-app-bar app>
    <v-toolbar-title>
      <span>Tickets</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <ButtonExcel v-if="$route.path === '/tickets'"/>
    <ButtonPrintTicket v-else/>
  </v-app-bar>
</template>

<script setup lang="ts">
import ButtonPrintTicket from '../components/button-print-ticket.vue';  
import ButtonExcel from '../components/button-excel.vue';
</script>
